// extracted by mini-css-extract-plugin
module.exports = {"container":"float_container__1lcx7","button":"float_button__Iz-sJ","child":"float_child__2tHKT","a":"float_a__PO7nw","b":"float_b__29TMG"};